module.exports = __webpack_public_path__ + "img/mile6m-m@2.3a90ee8e.webp";